import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportGroupFilterResponse } from './report-group-filter-api.types';

@Injectable({ providedIn: 'root' })
export class ReportGroupFilterApiService {
  private http = inject(HttpClient);

  getReportGroup(applicable: string): Observable<ReportGroupFilterResponse[]> {
    const applicableQueryParam = `?applicable=${applicable}`;
    return this.http.get<ReportGroupFilterResponse[]>(`/api/groups/filter${applicableQueryParam}`);
  }
}
